export default __webpack_public_path__ + "static/media/ava-2.11e918c6.jpg";